import { AuthenticatedUser, AuthStore, TokenResponse, UserInfo } from 'auth';
import { getAuthHeader } from './get-auth-header';
import { logger } from '@sanlam-glacier/app-common/modules/logger';
import { AuthNavigate } from 'auth/types/auth-navigate.type';
import { replaceWithDynamicHost } from 'utils/api/api-host-utils';
import { Env } from 'types/env/Env.type';
import { ResultOfAccessResponseViewModel } from 'bff/client/models/ResultOfAccessResponseViewModel';
import { Configuration, SecurityApi } from 'bff/client';

type CreateGetAccessProps = {
  getSignedInUser: () => AuthenticatedUser | undefined;
  setSignedInUser: (user: UserInfo) => void;
  env: Env;
  navigate: AuthNavigate;
};

const handleOnSuccess =
  (createGetAccessProps: CreateGetAccessProps) => (result: ResultOfAccessResponseViewModel) => {
    const { setSignedInUser } = createGetAccessProps;

    AuthStore.setUserInfo({
      display_name: `${result.data?.userInformation.firstName} ${result.data?.userInformation.surname}`,
      email: result.data?.userInformation.emailAddress ?? '',
      family_name: result.data?.userInformation.surname ?? '',
      given_name: result.data?.userInformation.firstName ?? '',
      sub: result.data?.userInformation.sanpayCode ?? '',
      groups: '',
      guid: '',
      name: result.data?.userInformation.firstName ?? '',
      phone_number: '',
      preferred_username: '',
      nickname: '',
      login: result.data?.userInformation.sanpayCode ?? ''
    });

    setSignedInUser({
      display_name: `${result.data?.userInformation.firstName} ${result.data?.userInformation.surname}`,
      email: result.data?.userInformation.emailAddress ?? '',
      family_name: result.data?.userInformation.surname ?? '',
      given_name: result.data?.userInformation.firstName ?? '',
      sub: result.data?.userInformation.sanpayCode ?? '',
      groups: '',
      guid: '',
      name: result.data?.userInformation.firstName ?? '',
      phone_number: '',
      preferred_username: '',
      nickname: '',
      login: result.data?.userInformation.sanpayCode ?? ''
    });
  };

export const getAccess =
  (createGetAccessProps: CreateGetAccessProps) =>
  async (authToken?: TokenResponse | undefined): Promise<boolean> => {
    const { env } = createGetAccessProps;

    const config = new Configuration({
      basePath: replaceWithDynamicHost(env.apiUrl, env.apiHostMappings),
      apiKey: getAuthHeader(
        replaceWithDynamicHost(env.apiUrl, env.apiHostMappings),
        true,
        env.auth.client.jwtProvider,
        authToken
      ),
      accessToken: authToken?.access_token
    });

    const securityApi = new SecurityApi(config);

    try {
      const response = await securityApi.securityGetAccess();
      handleOnSuccess(createGetAccessProps)(response);
      return true;
    } catch (error) {
      logger.error({ message: `${error}` });
      return false;
    }
  };
